// extracted by mini-css-extract-plugin
module.exports = {"event-table":"events_event-table__M3E9b","sort-button":"events_sort-button__Yvghf","hidden-mobile":"events_hidden-mobile__rwtCO"};